module.exports = __webpack_public_path__ + "static/media/video.0583b681.svg";